import { createApi} from '@reduxjs/toolkit/query/react';
import { ENDPOINT_URL, PORT_RANGE_ENTRIES_API, SWITCHES_ACE_IPV4_API, SWITCHES_ACE_IPV6_API, SWITCHES_ACE_MAC_API, SWITCHES_ACL_IPV4_API, SWITCHES_ACL_IPV6_API, SWITCHES_ACL_MAC_API } from '../../../../../constants/commonConstants';
import { decryptData,  encryptData } from '../../../../../utils/crypto';
import { axiosBaseQuery } from '../../../../../utils/axiosBaseQuery';
// Define the base API slice
export const accessControlQueryApiSlice = createApi({
    reducerPath: 'access_control_query_api',
    tagTypes: ['PortRangeEntries'],
    baseQuery: axiosBaseQuery({
        baseUrl: ENDPOINT_URL,
    }),
    endpoints: (builder) => ({
        getSwitchACLMAC: builder.mutation({
            query: ({ limit, offset, search = ''} = {}) => ({
                url: search
                    ? `${SWITCHES_ACL_MAC_API}?limit=${limit ?? 0}&offset=${offset ?? 0}&search=${encodeURIComponent(search)}`
                    : `${SWITCHES_ACL_MAC_API}?limit=${limit ?? 0}&offset=${offset ?? 0}`,
                method: 'GET',
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);
                return res?.data?.macAclProfileConfs;
            }
        }),
        createSwitchACLMAC: builder.mutation({
            query: (profileName) => ({
                url: `${SWITCHES_ACL_MAC_API}`,
                method: 'POST',
                body: `\"${encryptData(JSON.stringify({
                    profiles:
                        [
                            {
                                profileName
                            }
                        ]
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);
                if (res?.msg === 'MAXIMUM_LIMIT_EXCEEDED_FOR_MAC_ACL_PROFILES') {
                    throw Error("MAC ACL profile limit exceeded.");
                }
                if (res.status != 200) throw Error('Failed to create MAC ACL');

                return res?.data;
            }
        }),
        deleteSwitchACLMAC: builder.mutation({
            query: (entries) => ({
                url: `${SWITCHES_ACL_MAC_API}`,
                method: 'POST',
                body: `\"${encryptData(JSON.stringify({
                    delete_profiles: entries,
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);

                if (res.status !== 200) throw Error(res?.error ?? 'Failed to delete MAC ACL');

                return res?.data;
            },
        }),
        updateSwitchACLMAC: builder.mutation({
            query: (entries) => ({
                url: `${SWITCHES_ACL_MAC_API}`,
                method: 'PATCH',
                body: `\"${encryptData(JSON.stringify({
                    edit_entries: entries,
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);

                if (res.status !== 200) throw Error('Failed to update MAC ACL');

                return res?.data;
            },
        }),

        getSwitchACEMAC: builder.mutation({
            query: () => ({
                url: `${SWITCHES_ACE_MAC_API}`,
                method: 'GET',
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);
                return res?.data?.macAclEntryConfs;
            }
        }),
        createSwitchACEMAC: builder.mutation({
            query: (entry) => ({
                url: `${SWITCHES_ACE_MAC_API}`,
                method: 'POST',
                body: `\"${encryptData(JSON.stringify({
                    entries: [
                        entry
                    ]
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);

                if (res.status != 200) throw Error('Failed to create MAC ACE');

                return res?.data;
            }
        }),
        deleteSwitchACEMAC: builder.mutation({
            query: (entries) => ({
                url: `${SWITCHES_ACE_MAC_API}`,
                method: 'POST',
                body: `\"${encryptData(JSON.stringify({
                    delete_entries: entries,
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);

                if (res.status !== 200) throw Error('Failed to delete MAC ACE');

                return res?.data;
            },
        }),
        updateSwitchACEMAC: builder.mutation({
            query: (entries) => ({
                url: `${SWITCHES_ACE_MAC_API}`,
                method: 'PATCH',
                body: `\"${encryptData(JSON.stringify({
                    edit_entries: entries,
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);

                if (res.status !== 200) throw Error('Failed to update MAC ACE');

                return res?.data;
            },
        }),

		getSwitchACLIPv4: builder.mutation({
			query: ({ limit, offset, search = '' } = {}) => ({
				url: search 
                    ? `${SWITCHES_ACL_IPV4_API}?limit=${limit ?? 0}&offset=${offset ?? 0}&search=${encodeURIComponent(search)}`
                    : `${SWITCHES_ACL_IPV4_API}?limit=${limit ?? 0}&offset=${offset ?? 0}`,
                method: 'GET',
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);
                return res?.data?.ipv4AclProfileConfs;
            }
        }),
        createSwitchACLIPv4: builder.mutation({
            query: (profileName) => ({
                url: `${SWITCHES_ACL_IPV4_API}`,
                method: 'POST',
                body: `\"${encryptData(JSON.stringify({
                    profiles: [
                        {
                            profileName
                        }
                    ]
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);
                if (res?.msg === 'MAXIMUM_LIMIT_EXCEEDED_FOR_IPV4_ACL_PROFILES') {
                    throw Error("IPv4 ACL profile limit exceeded.");
                }
               if (res.status != 200) throw Error('Failed to create IPv4 ACL');
                

                return res?.data;
            }
        }),
        deleteSwitchACLIPv4: builder.mutation({
            query: (entries) => ({
                url: `${SWITCHES_ACL_IPV4_API}`,
                method: 'POST',
                body: `\"${encryptData(JSON.stringify({
                    delete_profiles: entries,
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);

                if (res.status !== 200) throw Error(res?.error ?? 'Failed to delete IPv4 ACL');

                return res?.data;
            },
        }),
        updateSwitchACLIPv4: builder.mutation({
            query: (entries) => ({
                url: `${SWITCHES_ACL_IPV4_API}`,
                method: 'PATCH',
                body: `\"${encryptData(JSON.stringify({
                    edit_entries: entries,
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);

                if (res.status !== 200) throw Error('Failed to update IPv4 ACL');

                return res?.data;
            },
        }),

        getSwitchACEIPv4: builder.mutation({
            query: () => ({
                url: `${SWITCHES_ACE_IPV4_API}`,
                method: 'GET',
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);
                return res?.data?.ipv4EntryProfileConfs;
            }
        }),
        createSwitchACEIPv4: builder.mutation({
            query: (entry) => {
                return ({
                url: `${SWITCHES_ACE_IPV4_API}`,
                method: 'POST',
                body: `\"${encryptData(JSON.stringify({
                    entries: [
                        {
                            ...entry,
                            Range_mode: {
                                src_profile: "",
                                dest_profile: ""
                            },
                        }
                    ]
                }))}\"`,
            });
            },
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);

                if (res.status != 200) throw Error('Failed to create IPv4 ACE');

                return res?.data;
            }
        }),
        deleteSwitchACEIPv4: builder.mutation({
            query: (entries) => ({
                url: `${SWITCHES_ACE_IPV4_API}`,
                method: 'POST',
                body: `\"${encryptData(JSON.stringify({
                    delete_entries: entries,
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);

                if (res.status !== 200) throw Error('Failed to delete IPv4 ACE');

                return res?.data;
            },
        }),
        updateSwitchACEIPv4: builder.mutation({
            query: (entries) => ({
                url: `${SWITCHES_ACE_IPV4_API}`,
                method: 'PATCH',
                body: `\"${encryptData(JSON.stringify({
                    edit_entries: entries,
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);

                if (res.status !== 200) throw Error('Failed to update IPv4 ACE');

                return res?.data;
            },
        }),

		getSwitchACLIPv6: builder.mutation({
			query: ({ limit, offset, search = '' } = {}) => ({
				url: search 
                    ? `${SWITCHES_ACL_IPV6_API}?limit=${limit ?? 0}&offset=${offset ?? 0}&search=${encodeURIComponent(search)}`
                    : `${SWITCHES_ACL_IPV6_API}?limit=${limit ?? 0}&offset=${offset ?? 0}`,
                method: 'GET',
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);
                return res?.data?.ipv6AclProfileConfs;
            }
        }),
        createSwitchACLIPv6: builder.mutation({
            query: (profileName) => ({
                url: `${SWITCHES_ACL_IPV6_API}`,
                method: 'POST',
                body: `\"${encryptData(JSON.stringify({
                    profiles: [
                        {
                            profileName
                        }
                    ]
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);
                if (res?.msg === 'MAXIMUM_LIMIT_EXCEEDED_FOR_IPV6_ACL_PROFILES') {
                    throw Error("IPv6 ACL profile limit exceeded.");
                }
                if (res.status != 200) throw Error('Failed to create IPv6 ACL');

                return res?.data;
            }
        }),
        deleteSwitchACLIPv6: builder.mutation({
            query: (entries) => ({
                url: `${SWITCHES_ACL_IPV6_API}`,
                method: 'POST',
                body: `\"${encryptData(JSON.stringify({
                    delete_profiles: entries,
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);

                if (res.status !== 200) throw Error(res?.error ?? 'Failed to delete IPv6 ACL');

                return res?.data;
            },
        }),
        updateSwitchACLIPv6: builder.mutation({
            query: (entries) => ({
                url: `${SWITCHES_ACL_IPV6_API}`,
                method: 'PATCH',
                body: `\"${encryptData(JSON.stringify({
                    edit_entries: entries,
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);

                if (res.status !== 200) throw Error('Failed to update IPv6 ACL');

                return res?.data;
            },
        }),

        getSwitchACEIPv6: builder.mutation({
            query: () => ({
                url: `${SWITCHES_ACE_IPV6_API}`,
                method: 'GET',
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);
                return res?.data?.ipv6EntryProfileConfs;
            }
        }),
        createSwitchACEIPv6: builder.mutation({
            query: (entry) => ({
                url: `${SWITCHES_ACE_IPV6_API}`,
                method: 'POST',
                body: `\"${encryptData(JSON.stringify({
                    entries: [
                        entry
                    ]
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);

                if (res.status != 200) throw Error('Failed to create IPv6 ACE');

                return res?.data;
            }
        }),
        deleteSwitchACEIPv6: builder.mutation({
            query: (entries) => ({
                url: `${SWITCHES_ACE_IPV6_API}`,
                method: 'POST',
                body: `\"${encryptData(JSON.stringify({
                    delete_entries: entries,
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);

                if (res.status !== 200) throw Error('Failed to delete IPv6 ACE');

                return res?.data;
            },
        }),
        updateSwitchACEIPv6: builder.mutation({
            query: (entries) => ({
                url: `${SWITCHES_ACE_IPV6_API}`,
                method: 'PATCH',
                body: `\"${encryptData(JSON.stringify({
                    edit_entries: entries,
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);

                if (res.status !== 200) throw Error('Failed to update IPv6 ACE');

                return res?.data;
            },
        }),
        getPortRangeEntries: builder.query({
            query: () => ({
                url: `${PORT_RANGE_ENTRIES_API}`,
                method: 'GET',
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);
                return res?.data?.aclRangeEntryProfileConfs;
            },
            providesTags: ['PortRangeEntries'],
        }),
        createPortRangeEntries: builder.mutation({
            query: (entry) => ({
                url: `${PORT_RANGE_ENTRIES_API}`,
                method: 'POST',
                body: `\"${encryptData(JSON.stringify({
                    entries: [
                        entry
                    ]
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);

                // Backend may return status=200 with msg indicating failure (e.g. duplicate profile name).
                if (res?.msg === 'PORT_RANGE_ACE_PROFILE_NAME_ALREADY_EXISTS') {
                    throw Error(res.msg);
                }
                if (res?.msg === 'PORT_RANGE_ACE_ENTRY_WITH_THIS_MIN_AND_MAX_PORTS_ALREADY_EXISTS') {
                    throw Error(res.msg);
                }
                if (res.status != 200) throw Error(res?.error ?? 'Failed to create Port range entry');

                return res?.data;
            },
            invalidatesTags: ['PortRangeEntries'],
        }),
        deletePortRangeEntries: builder.mutation({
            query: (entries) => ({
                url: `${PORT_RANGE_ENTRIES_API}`,
                method: 'POST',
                body: `\"${encryptData(JSON.stringify({
                    delete_entries: entries,
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);

                if (res.status !== 200) throw Error('Failed to delete Port range entry');

                return res?.data;
            },
            invalidatesTags: ['PortRangeEntries'],
        }),
        updatePortRangeEntries: builder.mutation({
            query: (entries) => ({
                url: `${PORT_RANGE_ENTRIES_API}`,
                method: 'PATCH',
                body: `\"${encryptData(JSON.stringify({
                    edit_entries: entries,
                }))}\"`,
            }),
            transformResponse: (response) => {
                const jsonString = decryptData(response);
                const res = JSON.parse(jsonString);

                if (res?.msg === 'PORT_RANGE_ACE_PROFILE_NAME_ALREADY_EXISTS') {
                    throw Error(res.msg);
                }
                if (res?.msg === 'PORT_RANGE_ACE_ENTRY_WITH_THIS_MIN_AND_MAX_PORTS_ALREADY_EXISTS') {
                    throw Error(res.msg);
                }
                if (res.status !== 200) throw Error('Failed to update Port range entry');

                return res?.data;
            },
            invalidatesTags: ['PortRangeEntries'],
        }),
    }),
});

export const {
    useGetSwitchACLMACMutation,
    useCreateSwitchACLMACMutation,
    useDeleteSwitchACLMACMutation,
    useUpdateSwitchACLMACMutation,
    useGetSwitchACEMACMutation,
    useCreateSwitchACEMACMutation,
    useDeleteSwitchACEMACMutation,
    useUpdateSwitchACEMACMutation,
    useGetSwitchACLIPv4Mutation,
    useCreateSwitchACLIPv4Mutation,
    useDeleteSwitchACLIPv4Mutation,
    useUpdateSwitchACLIPv4Mutation,
    useGetSwitchACEIPv4Mutation,
    useCreateSwitchACEIPv4Mutation,
    useDeleteSwitchACEIPv4Mutation,
    useUpdateSwitchACEIPv4Mutation,
    useGetSwitchACLIPv6Mutation,
    useCreateSwitchACLIPv6Mutation,
    useDeleteSwitchACLIPv6Mutation,
    useUpdateSwitchACLIPv6Mutation,
    useGetSwitchACEIPv6Mutation,
    useCreateSwitchACEIPv6Mutation,
    useDeleteSwitchACEIPv6Mutation,
    useUpdateSwitchACEIPv6Mutation,
    useGetPortRangeEntriesQuery,
    useCreatePortRangeEntriesMutation,
    useDeletePortRangeEntriesMutation,
    useUpdatePortRangeEntriesMutation,
} = accessControlQueryApiSlice;
